<template>
    <LottoFilterContainer lottoNamespace="ui/results/lotto" />
</template>

<script>
    import LottoFilterContainer from '@src/terminal/app/modules/shared/lotto/LottoFilterContainer';

    export default {
        name: 'LottoResultsLeftSidebar',
        components: {
            LottoFilterContainer,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/app/modules/results/leftSidebar/LottoSidebar.vue